// extracted by mini-css-extract-plugin
module.exports = {"newsletter":"newsletter_newsletter__2fd-t","alert":"newsletter_alert__Ek3H6"};